export default __webpack_public_path__ + "locales/vi/ConnectDialog.json?hash=aad7a7105f0628838b8ef7c516da3d92";